import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    lastSelectedJob: "",
    error: null
};

export const lastSelectedJobSlice = createSlice({
    name: "lastSelectedJobSlice",
    initialState,
    reducers: {
        resetLastSelectedJob: (state) => {
            state.lastSelectedJob = "";
        },
        setLastSelectedJob: (state, action) => {
            state.lastSelectedJob = action.payload;
        }
    }
});

export const { resetLastSelectedJob, setLastSelectedJob } = lastSelectedJobSlice.actions;

export const selectLastSelectedJob = (state) => state.lastSelectedJobSlice.lastSelectedJob;

